import { parsePath } from '@truqc/content-path';
import { createSelector } from 'reselect';
import newPathSelector from './newPathSelector';
import { getDocuments } from './simpleSelectors';
export default createSelector([getDocuments, newPathSelector], (documents, path) => {
  if (documents.length) {
    const docID = parsePath(path).reverse()[1]; // get second to last - last is `remotePath`
    const doc = documents.find(({
      id
    }) => id === docID);
    return !!(doc && doc.reportAnnotationObjects && doc.reportAnnotationObjects.length);
  }
  return false;
});